import React, { ReactNode } from 'react';

import PropTypes, { arrayOf, element, oneOfType } from 'prop-types';

import EngineContext from '../context/engine-context';
import Engine from '../engine';

import { EngineStuff } from './engine-stuff';
import StatefulFragment from './stateful-fragment';

export interface Props extends EngineStuff {
  fragment: string;
}

class Application extends React.PureComponent<Props> {

  static propTypes = {
    fragment: PropTypes.string,
    engine: PropTypes.instanceOf(Engine),
    children: oneOfType([element, arrayOf(element)]),
  };

  render(): ReactNode {
    const { fragment, engine, children } = this.props;

    return (
      <EngineContext.Provider value={{ engine }}>
        { children ? children : <StatefulFragment uuid={fragment} instanceUUID="root" fragment={fragment} /> }
      </EngineContext.Provider>
    );
  }

}

export default Application;
